import { Provider } from '@vgtv/api-client';

export const vendorToDnaBrand: Record<Provider, string> = {
  vgtv: 'vg',
  vgtvexternal: 'vg',
  ab: 'ab',
  e24: 'e24',
  ap: 'ap',
  bt: 'bt',
  sa: 'sa',
  svd: 'svd',
};
